import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Store } from "@ngrx/store";

import { catchError, map, concatMap, exhaustMap, withLatestFrom, filter, switchMap,takeLast,skipUntil, delay,delayWhen, tap, buffer,bufferWhen, bufferToggle  } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { environment } from "@environments/environment";
import { PowerBIEmbed, PowerBIReportNamesResponse } from "@models/powerBIEmbed.model";

@Injectable({
  providedIn: 'root'
})
export class PowerBIService {

  private apiUrl = environment.apiUrl;


  getEmbedToken(): Observable<PowerBIEmbed> {

    return this.http.get<PowerBIEmbed>(`${this.apiUrl}/powerBI/Reports`);
  }

  getReportNames(): Observable<PowerBIReportNamesResponse> {
    const params = new HttpParams().set('includeEmbedToken', 'false');
    return this.http.get<PowerBIReportNamesResponse>(`${this.apiUrl}/powerBI/Reports`, { params });
  }

  constructor(private http: HttpClient, private store: Store) {}

}
